import styled from "styled-components"
import { Container } from "../../styles/Container"

export const Wrapper = styled.div`
  margin: 5rem auto;

  ${Container}
`

export const Content = styled.div`
  width: 100%;
  padding: 1rem 0;

  text-align: center;

  h1 {
    font-size: 4rem;
    margin-bottom: 0;
  }
  p {
    margin-top: 0;
    font-size: 1rem;
    font-weight: 300;
  }
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;


  margin: 3rem 0;


  input,
  textarea {
    width: 60vw;
    border: solid 1px #ccc;
    border-radius: 4px;
    padding: 12px 20px;
    font-size: 1rem;
  }

  input {
    height: 60px;
  }
  textarea {
    height: 250px;
    resize: none;
  }
  label {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
  }
  Button {
    padding: 0.5rem 1.5rem;
  }
  p {
    color: #bf1650;
  }

  p::before {
    display: inline;
    content: "⚠ ";
  }
`

export const Divider = styled.div`
  border: 3px solid #ccc;
  height: 0px;
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    background-color: #fff;
    position: relative;
    width: 40px;
  }
`

export const Social = styled.div`
  margin-top: 5rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1rem;

  @media (max-width: 576px) {
    grid-template-columns: repeat(1, 1fr);
  }

  a {
    display: flex;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 2rem;
    .socialIcon {
      padding: 8px;
      border-radius: 5px;
      box-sizing: border-box;
      height: 40px;
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        //border: 1px solid #ccc;
        font-size: 24px;
      }
    }
    .description {
      padding-left: 18px;
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      font-weight: 300;
    }
    :hover {
      text-shadow: none !important;
    }
  }
`
